"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpPerformQuestionAsset = void 0;
const AssetModel_1 = __importDefault(require("@opsbase/lib-data-model/models/AssetModel"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const usePerform_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformController/usePerform"));
const usePerformQuestion_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestion"));
const usePerformQuestionActions_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestionActions"));
const useAssets_1 = require("@opsbase/react-gql-hooks/asset/useAssets");
const AssetChooser_1 = __importDefault(require("@opsbase/web-data-choosers/AssetChooser"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const TextFieldWithStateAndBlur_1 = __importDefault(require("@opsbase/web-textfield/TextFieldWithStateAndBlur"));
const Checkbox_1 = __importDefault(require("@opsbase/web-ui/Checkbox"));
const Spinner_1 = require("@opsbase/web-ui/Spinner");
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const consts_1 = require("../../consts");
const OpPerformQuestionCard_1 = __importDefault(require("../../OpPerformQuestionCard"));
function OpPerformQuestionAsset(props) {
    const { rule, answer } = (0, usePerformQuestion_1.default)();
    const { doChangeAnswer } = (0, usePerformQuestionActions_1.default)();
    const { placeId } = (0, usePerform_1.default)();
    const [listState, setListState] = (0, react_1.useState)([]);
    const [otherState, setOtherState] = (0, react_1.useState)('');
    const [isOther, setIsOther] = (0, react_1.useState)(false);
    const assetFound = (0, react_1.useRef)(true);
    const { doSkip } = (0, usePerformQuestionActions_1.default)();
    const { mode } = (0, usePerform_1.default)();
    const viewMode = mode === 'view';
    const { loading: lAsset, data: dAsset } = (0, useAssets_1.useAssetsCollection)({
        variables: {
            place: [placeId],
        },
    });
    if (!viewMode && (dAsset === null || dAsset === void 0 ? void 0 : dAsset.totalCount) <= 0) {
        assetFound.current = false;
    }
    (0, react_1.useEffect)(() => {
        if (viewMode)
            return;
        if (!assetFound.current) {
            if (!rule.allowCustomText) {
                doSkip(true, true);
            }
            else {
                doSkip(answer.notApplicable);
            }
            setIsOther(true);
        }
        else {
            doSkip(answer.notApplicable);
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [assetFound.current]);
    (0, react_1.useEffect)(() => {
        const { assets, other } = answerToAssets(answer);
        if (other) {
            setOtherState(other);
            setIsOther(true);
        }
        if (assets === null || assets === void 0 ? void 0 : assets.length) {
            setListState(assets);
        }
    }, [answer]);
    const handleChangeAnswer = (0, react_1.useCallback)((assets, otherStr) => {
        const newAnswer = mergeAnswers(assets, isOther ? otherStr : null);
        doChangeAnswer(newAnswer);
    }, [doChangeAnswer, isOther]);
    const handleChangeListState = (0, react_1.useCallback)(v => {
        setListState(v);
        handleChangeAnswer(v, otherState);
    }, [handleChangeAnswer, otherState]);
    const handleChangeOtherState = (0, react_1.useCallback)(str => {
        setOtherState(str);
        handleChangeAnswer(listState, str);
    }, [handleChangeAnswer, listState]);
    const handleToggleOther = (0, react_1.useCallback)(() => setIsOther(!isOther), [isOther]);
    return (0, react_1.useMemo)(() => {
        const showList = assetFound.current
            ? viewMode
                ? listState === null || listState === void 0 ? void 0 : listState.length
                : !(isOther && !rule.allowMultiSelect)
            : false;
        const showOther = !!isOther;
        const showToggle = viewMode ? false : rule.allowCustomText;
        return (react_1.default.createElement(Spinner_1.Spinner, { busy: lAsset },
            react_1.default.createElement(OpPerformQuestionCard_1.default, Object.assign({}, props, { disableChildren: viewMode }),
                react_1.default.createElement(Vertical_1.default, { padding: true },
                    react_1.default.createElement(Pane_1.default, null,
                        !!showList && (react_1.default.createElement(AssetChooser_1.default, { selectLabel: lib_i18n_1.default.t('select-asset-list'), multi: rule.allowMultiSelect, value: listState, filters: { place: [placeId] }, onChange: handleChangeListState })),
                        !!showOther && (react_1.default.createElement(TextFieldWithStateAndBlur_1.default, { fullWidth: true, noMargin: viewMode, inputProps: { style: consts_1.performInputStyle }, placeholder: lib_i18n_1.default.t('enter-asset-name'), value: otherState, onBlur: handleChangeOtherState }))),
                    !!showToggle && (react_1.default.createElement(Horizontal_1.default, { centered: true, justify: "flex-start" },
                        react_1.default.createElement(Checkbox_1.default, { checked: isOther, onChange: handleToggleOther }),
                        react_1.default.createElement(Text_1.default, { onClick: handleToggleOther }, lib_i18n_1.default.t('enter-asset-other'))))))));
    }, [
        lAsset,
        viewMode,
        listState,
        isOther,
        rule,
        props,
        placeId,
        handleChangeListState,
        otherState,
        handleChangeOtherState,
        handleToggleOther,
    ]);
}
exports.OpPerformQuestionAsset = OpPerformQuestionAsset;
exports.default = OpPerformQuestionAsset;
function answerToAssets(answer) {
    var _a, _b;
    if (!answer.value)
        return {};
    const values = ((_a = answer.value) === null || _a === void 0 ? void 0 : _a.split(', ')) || [];
    const texts = ((_b = answer.text) === null || _b === void 0 ? void 0 : _b.split(', ')) || [];
    if (!values.length || values.length !== texts.length)
        return {};
    const assets = [];
    const remaining = [];
    for (let i = 0; i < values.length; i++) {
        const v = values[i];
        const t = texts[i];
        if (v === t) {
            remaining.push(v);
        }
        else {
            assets.push(new AssetModel_1.default({ id: v, title: t }));
        }
    }
    return { assets, other: remaining.join('') };
}
function mergeAnswers(assets, other) {
    return {
        value: [...assets.map(v => v.id), ...(other ? [other] : [])].join(', '),
        text: [...assets.map(v => v.title), ...(other ? [other] : [])].join(', '),
    };
}
